import z from 'zod';

import {
  RECORD_STATUS_FILTER_OPTIONS,
  RecordStatusSchema,
  type SuperadminOrganizationsRecordStatusFilter,
} from './superadminOrganizationsSearch';

export type SuperadminUsersRecordStatusFilter = SuperadminOrganizationsRecordStatusFilter;

export const UsersSearchParamsSchema = z.object({
  search: z.string().optional(),
  recordStatus: RecordStatusSchema.optional(),
  sortBy: z.enum(['name', 'created', 'lastVisited']).optional(),
  sortDirection: z.enum(['asc', 'desc']).optional(),
});

export { RECORD_STATUS_FILTER_OPTIONS, RecordStatusSchema };
